import React from "react";
import { useTranslation } from "react-i18next";

function joinClasses(...classes) {
  return classes.filter(Boolean).join(" ");
}

export function ResultViewHeader({ title, recordingTime }) {
  const time = recordingTime?.time || "";
  const date = recordingTime?.date || "";

  return (
    <div className="flex flex-col w-full h-fit items-center justify-center gap-1">
      <h1 className="subtitle-text">{title}</h1>
      {time || date ? <p className="muted-text">{time} {date}</p> : null}
    </div>
  );
}

function ResultViewScaffold({
  title,
  recordingTime,
  onFinish,
  children,
  details = null,
  outerClassName = "",
  summaryClassName = "",
}) {
  const { t } = useTranslation();

  return (
    <div
      className={joinClasses(
        "w-full max-w-lg h-full min-h-0 overflow-y-auto",
        outerClassName,
      )}
    >
      <section className="min-h-full p-4 pt-0 sm:pt-4 flex flex-col justify-between items-center text-center gap-4">
        <div
          className={joinClasses(
            "w-full h-fit flex flex-col gap-2 justify-start items-center text-center",
            summaryClassName,
          )}
        >
          <ResultViewHeader title={title} recordingTime={recordingTime} />
          {children}
        </div>

        <button
          type="button"
          className="primary-button w-full"
          onClick={onFinish}
        >
          {t("result.finish", "Finish")}
        </button>
      </section>

      {details}
    </div>
  );
}

export default ResultViewScaffold;
